module.exports = __webpack_public_path__ + "static/media/detail13.806cffd0.jpg";